import { axiosInstance } from "api/axios-config/axios-config";
import { OptionItem } from "commons/ultilities/dynamic-form/models/control";
import {
  IAddMaterialGoodsReceipt,
  IUpdateMaterialGoodsReceipt,
} from "mobx-stores/_models/material-inventory/material-goods-receipt/material-goods-receipt";
import { IMaterialGoodsReceiptItemProperties } from "mobx-stores/_models/material-inventory/material-goods-receipt/material-goods-receipt-item";
import { BaseBussiness } from "../base";

class MaterialGoodsReceiptBusiness extends BaseBussiness<
  IMaterialGoodsReceiptItemProperties,
  IAddMaterialGoodsReceipt,
  IUpdateMaterialGoodsReceipt,
  IMaterialGoodsReceiptItemProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  public getReceiptedBrandOptions = async (
    materialId: string,
    showZeroQuantity = false,
  ): Promise<OptionItem[]> => {
    var res = await axiosInstance.get(
      `${this.url}/receipted-brand-by-material-id/${materialId}`,
      {
        params: {
          showZeroQuantity,
        },
      },
    );
    const seen = new Set<string>();
    const options: OptionItem[] = [];

    for (const item of res.data ?? []) {
      if (item.brand && !seen.has(item.brand)) {
        seen.add(item.brand);
        options.push({ value: item.brand, label: item.brand });
      }
    }
    return options;
  };
}

export const materialGoodsReceiptBusiness = new MaterialGoodsReceiptBusiness(
  "/api/app/material-goods-receipt",
);
